(function () {
  var VARIANT_SCRIPT_SELECTOR = '.geeko-card-quick-add__variants';
  var SIZE_SELECTOR = '.geeko-card-quick-add__size';
  var OVERLAY_SELECTOR = '.geeko-card-quick-add';
  var TRIGGER_SELECTOR = '.geeko-card-quick-add__trigger';
  var SHEET_SELECTOR = '.geeko-card-quick-add-sheet';
  var SHEET_SIZE_SELECTOR = '.geeko-card-quick-add-sheet__size';
  var SHEET_HISTORY_KEY = 'geeko-card-quick-add-sheet';
  var CART_SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];
  var variantCache = new WeakMap();
  var sourceOverlay = null;
  var sourceTrigger = null;
  var sheetPushedHistory = false;

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function isCartReady(cart) {
    return Boolean(
      cart &&
        typeof cart.getSectionsToRender === 'function' &&
        typeof cart.renderContents === 'function'
    );
  }

  function getSectionsParam(cart) {
    if (isCartReady(cart)) {
      return cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
    }
    // cart-drawer.js 尚未升级 custom element 时仍要请求 sections，否则抽屉会空白
    return CART_SECTION_IDS.join(',');
  }

  function waitForCart(timeoutMs) {
    return new Promise(function (resolve) {
      var cart = getCart();
      if (isCartReady(cart)) {
        resolve(cart);
        return;
      }

      var timeout = timeoutMs || 5000;
      var start = Date.now();
      var timer = setInterval(function () {
        cart = getCart();
        if (isCartReady(cart) || Date.now() - start >= timeout) {
          clearInterval(timer);
          resolve(isCartReady(cart) ? cart : null);
        }
      }, 50);
    });
  }

  function ensureCartSections(response) {
    if (response && response.sections && response.sections['cart-drawer']) {
      return Promise.resolve(response);
    }

    return fetch(
      window.routes.cart_url + '?sections=' + encodeURIComponent(CART_SECTION_IDS.join(','))
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        response.sections = sections;
        return response;
      });
  }

  function renderCartAfterAdd(response) {
    return waitForCart()
      .then(function (cart) {
        if (!cart) {
          window.location = window.routes.cart_url;
          return null;
        }
        return ensureCartSections(response).then(function (readyResponse) {
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
          cart.renderContents(readyResponse);
          return cart;
        });
      })
      .catch(function (error) {
        console.error(error);
        window.location = window.routes.cart_url;
      });
  }

  function getSheet() {
    return document.querySelector(SHEET_SELECTOR);
  }

  function optionKey(position) {
    return 'option' + position;
  }

  function parseVariants(overlay) {
    if (variantCache.has(overlay)) return variantCache.get(overlay);

    var script = overlay.querySelector(VARIANT_SCRIPT_SELECTOR);
    var variants = [];
    if (script) {
      try {
        variants = JSON.parse(script.textContent);
      } catch (error) {
        variants = [];
      }
    }
    variantCache.set(overlay, variants);
    return variants;
  }

  function getCurrentColor(overlay) {
    var colorPosition = Number(overlay.dataset.colorPosition || 0);
    if (!colorPosition) return '';

    var productInfo = overlay.closest('product-info');
    if (!productInfo) return '';

    var checked =
      productInfo.querySelector('.geeko-Color input:checked') ||
      productInfo.querySelector('.geeko-Colour input:checked') ||
      productInfo.querySelector('.wbswatchclr input:checked');

    return checked ? checked.value : '';
  }

  function findVariant(overlay, size) {
    var variants = parseVariants(overlay);
    var sizePosition = Number(overlay.dataset.sizePosition || 0);
    var colorPosition = Number(overlay.dataset.colorPosition || 0);
    var color = getCurrentColor(overlay);
    var sizeKey = optionKey(sizePosition);
    var colorKey = optionKey(colorPosition);
    var fallback = null;

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (String(variant[sizeKey]) !== String(size)) continue;
      if (colorPosition && color && String(variant[colorKey]) !== String(color)) continue;
      if (variant.available) return variant;
      if (!fallback) fallback = variant;
    }

    return fallback;
  }

  function updateSizeAvailability(overlay) {
    var buttons = overlay.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var variant = findVariant(overlay, button.dataset.size);
      var available = Boolean(variant && variant.available);
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
      button.classList.toggle('geeko-card-quick-add__size--unavailable', !available);
    }
  }

  function setBusy(overlay, busy) {
    overlay.classList.toggle('is-loading', busy);
    overlay.setAttribute('aria-busy', busy ? 'true' : 'false');

    var sheet = getSheet();
    if (sheet && sourceOverlay === overlay) {
      sheet.classList.toggle('is-loading', busy);
      sheet.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    var buttons = overlay.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (busy) buttons[i].setAttribute('aria-disabled', 'true');
    }

    if (sheet) {
      var sheetButtons = sheet.querySelectorAll(SHEET_SIZE_SELECTOR);
      for (var j = 0; j < sheetButtons.length; j++) {
        if (busy) {
          sheetButtons[j].setAttribute('aria-disabled', 'true');
        }
      }
    }

    if (!busy) {
      updateSizeAvailability(overlay);
      if (sheet && sourceOverlay === overlay) fillSheetSizes(overlay);
    }
  }

  function fillSheetSizes(overlay) {
    var sheet = getSheet();
    if (!sheet) return;

    var list = sheet.querySelector('.geeko-card-quick-add-sheet__sizes');
    if (!list) return;

    list.innerHTML = '';
    var sourceButtons = overlay.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < sourceButtons.length; i++) {
      var source = sourceButtons[i];
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'geeko-card-quick-add-sheet__size';
      if (source.classList.contains('geeko-card-quick-add__size--unavailable') || source.disabled) {
        button.classList.add('geeko-card-quick-add__size--unavailable');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
      button.dataset.size = source.dataset.size || '';
      button.textContent = source.textContent.trim();
      button.setAttribute('aria-label', source.getAttribute('aria-label') || button.textContent);
      list.appendChild(button);
    }
  }

  function openSheet(overlay, trigger) {
    var sheet = getSheet();
    if (!sheet) return;

    sourceOverlay = overlay;
    sourceTrigger = trigger || null;
    updateSizeAvailability(overlay);
    fillSheetSizes(overlay);

    sheet.hidden = false;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('geeko-card-quick-add-sheet-open');

    var closeBtn = sheet.querySelector('.geeko-card-quick-add-sheet__close');
    if (closeBtn) closeBtn.focus();

    if (!sheetPushedHistory) {
      try {
        history.pushState({ [SHEET_HISTORY_KEY]: true }, '');
        sheetPushedHistory = true;
      } catch (error) {}
    }
  }

  function closeSheet(options) {
    var opts = options || {};
    var sheet = getSheet();
    if (!sheet || !sheet.classList.contains('is-open')) return;

    sheet.classList.remove('is-open', 'is-loading');
    sheet.removeAttribute('aria-busy');
    document.documentElement.classList.remove('geeko-card-quick-add-sheet-open');

    var list = sheet.querySelector('.geeko-card-quick-add-sheet__sizes');
    if (list) list.innerHTML = '';

    window.setTimeout(function () {
      if (!sheet.classList.contains('is-open')) sheet.hidden = true;
    }, 220);

    if (sourceTrigger) {
      sourceTrigger.focus();
    }

    sourceOverlay = null;
    sourceTrigger = null;

    if (sheetPushedHistory && !opts.fromPopstate) {
      sheetPushedHistory = false;
      try {
        history.back();
      } catch (error) {}
    } else {
      sheetPushedHistory = false;
    }
  }

  function addToCart(overlay, button, fromSheet) {
    if (overlay.classList.contains('is-loading') || button.disabled) return;

    var variant = findVariant(overlay, button.dataset.size);
    if (!variant || !variant.available || !variant.id) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('geeko-card-quick-add__size--unavailable');
      return;
    }

    var cart = getCart();
    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', 1);
    formData.append('sections', getSectionsParam(cart));
    formData.append('sections_url', window.location.pathname);

    if (isCartReady(cart) && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
          };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    setBusy(overlay, true);
    button.classList.add('is-adding');

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-quick-add',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          if (variant) variant.available = false;
          return null;
        }

        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-quick-add',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }

        if (fromSheet) closeSheet();
        return renderCartAfterAdd(response);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('is-adding');
        if (sourceOverlay === overlay || !fromSheet) {
          setBusy(overlay, false);
        } else {
          overlay.classList.remove('is-loading');
          overlay.removeAttribute('aria-busy');
          updateSizeAvailability(overlay);
        }
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      var overlay = trigger.closest(OVERLAY_SELECTOR);
      if (overlay) openSheet(overlay, trigger);
      return;
    }

    var sheetSize = event.target.closest(SHEET_SIZE_SELECTOR);
    if (sheetSize) {
      event.preventDefault();
      event.stopPropagation();
      if (!sourceOverlay || sheetSize.disabled) return;
      addToCart(sourceOverlay, sheetSize, true);
      return;
    }

    var sheet = getSheet();
    if (sheet && sheet.classList.contains('is-open')) {
      if (
        event.target.closest('.geeko-card-quick-add-sheet__overlay') ||
        event.target.closest('.geeko-card-quick-add-sheet__close')
      ) {
        event.preventDefault();
        closeSheet();
        return;
      }
    }

    var button = event.target.closest(SIZE_SELECTOR);
    if (!button) return;
    if (button.closest(SHEET_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();

    var cardOverlay = button.closest(OVERLAY_SELECTOR);
    if (!cardOverlay) return;
    addToCart(cardOverlay, button, false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var sheet = getSheet();
    if (sheet && sheet.classList.contains('is-open')) {
      event.preventDefault();
      closeSheet();
    }
  });

  window.addEventListener('popstate', function () {
    var sheet = getSheet();
    if (sheet && sheet.classList.contains('is-open')) {
      sheetPushedHistory = false;
      closeSheet({ fromPopstate: true });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var fieldset = input.closest('fieldset');
    var isColor =
      (fieldset && /geeko-colou?r/i.test(fieldset.className)) ||
      input.closest('.wbswatchclr');
    if (!isColor) return;

    var productInfo = input.closest('product-info');
    var overlay = productInfo && productInfo.querySelector(OVERLAY_SELECTOR);
    if (overlay) updateSizeAvailability(overlay);
  });
})();
